// extracted by css-extract-rspack-plugin
export default {"navigationCursor":"NavigationCursor-module__navigationCursor__r8QJd"};